// extracted by mini-css-extract-plugin
export default {"heading":"Lt-z","corrected":"Mt-z","redirectVerbiageContainer":"Nt-z","redirectVerbiageText":"Ot-z"};